import { render, staticRenderFns } from "./PaypalView.vue?vue&type=template&id=bc0c307a&lang=pug"
import script from "./PaypalView.vue?vue&type=script&lang=js"
export * from "./PaypalView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports